module.exports = __webpack_public_path__ + "images/Planet_Fitness-5e0ae2.png";